import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import CtaPrimary from 'components/ui/CtaPrimary';
import LanguageOptionsCentered from 'components/shared/LanguageOptionsCentered';

const StyledContainer = styled.div`
  background: #ffffff;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 20px;
  margin-top: 40px;
  padding: 30px;
`;

const StyledTitleText = styled.div`
  font-weight: 500;
  font-size: 24px;
`;

const StyledBodyText = styled.div`
  font-size: 16px;
  color: #626466;
  margin-top: 16px;
`;

const StyledButton = styled(CtaPrimary)`
  background-color: ${props => (props.disabled ? colors.LIGHT_GREY : colors.GREY_BLUE)} !important;
  color: ${props => (props.disabled ? colors.CHAR_COUNT : colors.STATE_BLUE)} !important;
  font-size: 18px;
  font-weight: 500;
  width: 270px;
  height: 48px;
  line-height: 48px;
  text-transform: capitalize;
`;

const Centred = styled.div`
  text-align: center;
  margin-top: 32px;
`;

const StyledLanguageOptionsCenteredContainer = styled.div`
  margin-top: 40px;
`;

const AcknowledgeTicket = ({ handleAcknowledge, buttonDisabled = false }) => {
  return (
    <StyledContainer>
      <StyledTitleText>
        {getTranslatedString('maintenanceVendors.acknowledge.title')}
      </StyledTitleText>
      <StyledBodyText>{getTranslatedString('maintenanceVendors.acknowledge.body')}</StyledBodyText>
      <Centred>
        <StyledButton onClick={handleAcknowledge} disabled={buttonDisabled}>
          {getTranslatedString('maintenanceVendors.acknowledge.button')}
        </StyledButton>
      </Centred>
      <StyledLanguageOptionsCenteredContainer>
        <LanguageOptionsCentered onLanguageChange={() => window.location.reload()} />
      </StyledLanguageOptionsCenteredContainer>
    </StyledContainer>
  );
};

export default AcknowledgeTicket;
